import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UrlRankError, UrlRankResult } from '../Model/UrlRank';

interface UrlRankState {
  loading: boolean;
  polling: boolean;
  jobId: string | null;
  searchRange: number | null;
  result: UrlRankResult | null;
  error: UrlRankError | null;
}

const initialState: UrlRankState = {
  loading: false,
  polling: false,
  jobId: null,
  searchRange: null,
  result: null,
  error: null,
};

const urlRankSlice = createSlice({
  name: 'urlRank',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPolling: (state, action: PayloadAction<boolean>) => {
      state.polling = action.payload;
    },
    setJob: (state, action: PayloadAction<{ jobId: string; searchRange?: number | null }>) => {
      state.jobId = action.payload.jobId;
      state.searchRange = action.payload.searchRange ?? null;
      state.polling = true;
      state.loading = false;
      state.error = null;
      state.result = null;
    },
    setResult: (state, action: PayloadAction<UrlRankResult>) => {
      state.result = action.payload;
      state.error = null;
      state.loading = false;
      state.polling = false;
      if (action.payload.search_range != null) {
        state.searchRange = action.payload.search_range;
      }
    },
    setError: (state, action: PayloadAction<UrlRankError>) => {
      state.error = action.payload;
      state.result = null;
      state.loading = false;
      state.polling = false;
      state.jobId = null;
    },
    clearUrlRankState: () => initialState,
  },
});

export const {
  setLoading,
  setPolling,
  setJob,
  setResult,
  setError,
  clearUrlRankState,
} = urlRankSlice.actions;
export default urlRankSlice.reducer;
